import cs from 'classnames';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, NavLink } from 'react-router-dom';
import { HEADER_MENU_LIST } from '../../config/consts';
import HamburgerMenu from './components/HamburgerMenu';
import classes from './style.module.scss';

export default function Header() {
  const { t } = useTranslation();
  const [mobileMenuActive, setMobileMenuActive] = useState(false);
  const handleLinkActive = (match, location) =>
    location.pathname === match?.url;

  useEffect(() => {
    const overfLow = mobileMenuActive ? 'hidden' : 'auto';
    document.body.style.overflow = overfLow;
  }, [mobileMenuActive]);

  return (
    <>
      <div className={cs(classes.container, classes.fixed)}>
        <div className={classes.logo}>
          <Link to="/">
            <img src="/logo.png" alt="Bitexen" />
          </Link>
        </div>
        <div className={classes.menu}>
          <div className={classes.mobile}>
            <HamburgerMenu
              active={mobileMenuActive}
              onClick={() => setMobileMenuActive(!mobileMenuActive)}
            />
          </div>
          <div className={classes.desktop}>
            {HEADER_MENU_LIST(t).map(({ text, url }, index) => (
              <div key={index.toString()} className={classes.menuItem}>
                <NavLink
                  to={url}
                  activeClassName={classes.active}
                  isActive={handleLinkActive}
                >
                  {text}
                </NavLink>
              </div>
            ))}
          </div>
        </div>
      </div>
      {mobileMenuActive && (
        <div className={classes.mobileMenuContainer}>
          {HEADER_MENU_LIST(t).map(({ text, url }, index) => (
            <div key={index.toString()} className={classes.mobileMenuItem}>
              <NavLink
                to={url}
                activeClassName={classes.active}
                isActive={handleLinkActive}
                onClick={() => setMobileMenuActive(false)}
              >
                {text}
              </NavLink>
            </div>
          ))}
        </div>
      )}
    </>
  );
}
